<template
  ><div class="my-2">
    <h3>Loan Collection Officer Stats</h3>
    <div class=" row">
      <div
        class="col-xl-4 col-lg-4 col-12 px--5 shadow rounded-1 mt-1 mx-1"
        v-for="(item, index) in kpiArr"
        :key="index"
        style="padding: 0.7rem;"
      >
        <div class="d-flex justify-content-between">
          <div>
            <h2>
              {{ item.first_name }} {{ item.last_name
              }} - {{ item.collection_group  }}<span style="font-size: 17px"></span>
            </h2>
          </div>
          <div>
            <ClipboardIcon />
          </div>
        </div>

        <KeyValue
          objKey="Allocated Loan"
          :objValue="item.loan_collector_stats.allocated_loans"
          :showBullet="true"
        />
        <KeyValue
          objKey="Completed Loans"
          :objValue="item.loan_collector_stats.completed_loans"
          :showBullet="true"
        />
        <KeyValue
          objKey="Total Assigned Cases"
          :objValue="item.loan_collector_stats.total_assigned_cases"
          :showBullet="true"
        />
        <KeyValue
          objKey="Overdue Loans"
          :objValue="item.loan_collector_stats.overdue_loans"
          :showBullet="true"
        />        
        <KeyValue
          objKey="Loans Running Assigned"
          :objValue="item.loan_collector_stats.loans_not_overdue"
          :showBullet="true"
        />        
        <KeyValue
          objKey="All Time Call Rate"
          :objValue="item.loan_collector_stats.all_call_rate"
          :showBullet="true"
        />
        <KeyValue
          objKey="Today's Call Rate"
          :objValue="item.loan_collector_stats.call_rate_today"
          :showBullet="true"
        />
        <KeyValue
          objKey="Call Rate This week"
          :objValue="item.loan_collector_stats.call_rate_this_week"
          :showBullet="true"
        />
        <KeyValue
          objKey="Delegated Amount"
          :objValue="item.loan_collector_stats.delegated_amount"
          :showBullet="true"
          :showCurrency="true"
        />
        <KeyValue
          objKey="Recovered Amount"
          :objValue="item.loan_collector_stats.recovered_amount"
          :showBullet="true"
          :showCurrency="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import KeyValue from "@/components/KeyValue.vue";
import ApiService from "@/services/api.service";
import { ClipboardIcon, CreditCardIcon } from "vue-feather-icons";
export default {
  name: "CollectionOfficerStat",
  components: {
    KeyValue,
    ClipboardIcon,
    CreditCardIcon
  },
  data() {
    return {
      kpiArr: [],
      kpiLoading: false
    };
  },
  methods: {
    async getStats() {
      try {
        this.kpiLoading = true;
        const res = await ApiService.get(
          "loan/instant/loan_collection_officer_stats"
        );
        // console.log(res);
        this.kpiArr = res.data.data;

        // console.log(res.data.data.length);
        this.kpiLoading = false;
      } catch (error) {
        // console.log("error.response");
        this.kpiLoading = false;
      }
    }
  },
  mounted() {
    this.getStats();
  }
};
</script>

<style scoped></style>
